import { useState } from "react";
import AutomationListImportContactsModal from "./AutomationListImportContactsModal/index";
import toast from "react-hot-toast";
import IconWithTooltipButton from "../../automation/shared/IconWithTooltipButton";
import { gql, useQuery } from "@apollo/client";
import {
  AutomationListImportContacts_PermissionsQuery,
  AutomationListImportContacts_PermissionsQueryVariables,
} from "../../../__generated__/graphql";
import FileUploadIcon from "../../../assets/img/icons/FileUploadIcon";

const AutomationListImportContacts_Permissions = gql`
  query AutomationListImportContacts_Permissions {
    permissions {
      canUploadContactCSVs
    }
  }
`;

interface IAutomationListImportContactsProps {
  contactListId: number;
  onContactsImported?: () => void;
}

const AutomationListImportContacts = ({
  contactListId,
  onContactsImported,
}: IAutomationListImportContactsProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, loading } = useQuery<
    AutomationListImportContacts_PermissionsQuery,
    AutomationListImportContacts_PermissionsQueryVariables
  >(AutomationListImportContacts_Permissions);
  const canUploadContactCSVs = data?.permissions?.canUploadContactCSVs;

  const handleSuccess = () => {
    toast.success("Contacts imported successfully!");
    if (onContactsImported) {
      onContactsImported();
    }
  };

  return (
    <>
      <IconWithTooltipButton
        tooltipMessage={`Import contacts from CSV ${
          !loading && !canUploadContactCSVs ? " (Pro feature)" : ""
        }`}
        icon={<FileUploadIcon height="18" width="18" />}
        onButtonClick={() => setIsModalOpen(true)}
        analyticsField="open import contacts modal"
        disabled={!canUploadContactCSVs}
        isLoading={false}
      />

      <AutomationListImportContactsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        contactListId={contactListId}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default AutomationListImportContacts;
